module.exports = __webpack_public_path__ + "img/cover-recipyapi.2b3bd1f6.png";